const CorvusUtility =
{
    redirectToPaymentForm(corvusForm: any) {
        (document.querySelector('html') as any).innerHTML = corvusForm;
        ((window.document as any).corvusPay).submit();
    }
}

export default CorvusUtility;